import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { brandConfiguration } from "@/brands/config";
import { envPrefix } from "@/brands/utils/envPrefix";
import { useSellerLeadLink } from "@/components/Sections/SellerLeadTeaser";
import { Section } from "@/components/UI";
import { useRefsContext } from "@/contexts/ref";
import { useMediumLink } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { Box, useBreakpointValue } from "@gemini/core";
import { Link, LoadingState } from "@gemini/ui";
import { lazy, Suspense } from "react";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
const AddressEntryPointModule = lazy(() => import("mfe_esfu_addressEntryPoint"));
export const SellerLeadTeaser = () => {
    const isPreviewMode = useIsPreviewMode();
    const { id, locale, portal, estimationFunnelRoute } = brandConfiguration;
    const { t } = useI18n();
    const { funnel: funnelUrl, landing: landingUrl } = useSellerLeadLink();
    const { sellerLeadTeaserRef } = useRefsContext();
    const mediumLink = useMediumLink("SellerLead");
    const isMobile = useBreakpointValue({
        base: true,
        md: false,
    });
    if (isPreviewMode || !funnelUrl)
        return null;
    return (_jsxs(Section, { ref: sellerLeadTeaserRef, unsafeClassname: "HideOnPrint", hasDivider: false, children: [_jsxs(Box, { as: "h2", typography: "typography.headline.20.bold", textAlign: "center", margin: "spacing.none", marginBottom: "spacing.16", display: "flex", flexWrap: "wrap", justifyContent: "center", children: [_jsx(Box, { as: "span", marginRight: "spacing.8", children: t("seller_lead_teaser.headline_one") }), _jsx(Box, { as: "span", children: t("seller_lead_teaser.headline_two") })] }), _jsx(Suspense, { fallback: _jsx(LoadingState, {}), children: _jsx(AddressEntryPointModule, { context: "estimation_funnel", parentApp: "classified_detail_page", portal: id === null || id === void 0 ? void 0 : id.toUpperCase(), lang: locale, ctaButtonInfo: {
                        url: `https://${envPrefix(".", "www")}${portal}${estimationFunnelRoute}`,
                    }, geo: {
                        placeTypes: ["STRT", "HONU"],
                    } }) }), _jsx(Box, { marginTop: {
                    "breakpoint.base": "spacing.24",
                    "breakpoint.md": "spacing.16",
                    "breakpoint.lg": "spacing.24",
                    "breakpoint.xl": "spacing.16",
                }, display: "flex", justifyContent: isMobile ? "center" : "start", children: _jsx(Link, { isExternal: true, 
                    //@ts-ignore
                    href: landingUrl, "data-tracking": mediumLink, children: t("seller_lead_teaser.link") }) })] }));
};
